var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useState, useRef, useEffect } from "react";
import styles from "./index.module.less";
import IconFont from "../IconFontV2";
import ResizeObserver from 'resize-observer-polyfill';
import { GridContextProvider, GridDropZone, GridItem, swap } from "@jd/me-react-grid-dnd";
function RowGrid(props) {
    var _a = props.items, items = _a === void 0 ? [] : _a, _b = props.itemWidth, itemWidth = _b === void 0 ? 50 : _b, _c = props.maxUnExpendRow, maxUnExpendRow = _c === void 0 ? 2 : _c, _d = props.expanded, expanded = _d === void 0 ? false : _d, onExpandChange = props.onExpandChange, renderItem = props.renderItem, onSort = props.onSort, getKey = props.getKey, getNumPiecesPartFunction = props.getNumPiecesPartFunction;
    var containerRef = useRef(null);
    var scrollContainerRef = useRef(null);
    var _e = useState(5), maxPerRow = _e[0], setMaxPerRow = _e[1];
    var _f = useState([]), displayList = _f[0], setDisplayList = _f[1];
    var _g = React.useState(null), scrollContainer = _g[0], setScrollContainer = _g[1];
    useEffect(function () {
        if (scrollContainerRef.current) {
            setScrollContainer(scrollContainerRef.current);
        }
    }, []);
    // 响应容器宽度变化，动态计算每行可放多少个
    useEffect(function () {
        if (!containerRef.current)
            return;
        var lastWidth = 0;
        // 防抖函数
        var debounce = function (func, delay) {
            var timer;
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                clearTimeout(timer);
                timer = setTimeout(function () { return func.apply(void 0, args); }, delay);
            };
        };
        var handleResize = debounce(function (entry) {
            var width = entry.contentRect.width;
            if (Math.abs(width - lastWidth) > 5) {
                var count = Math.max(1, Math.floor(width / itemWidth));
                setMaxPerRow(count);
                lastWidth = width;
            }
        }, 100); // 100ms防抖
        var observer = new ResizeObserver(function (entries) {
            var entry = entries[0];
            handleResize(entry);
        });
        observer.observe(containerRef.current);
        return function () { return observer.disconnect(); };
    }, [itemWidth, items.length]);
    // 折叠/展开逻辑
    var total = (items === null || items === void 0 ? void 0 : items.length) || 0;
    var maxVisible = maxPerRow * maxUnExpendRow;
    // let showDropdown = false;
    useEffect(function () {
        var list = [];
        if (!expanded && total > maxVisible) {
            list = items.slice(0, maxPerRow * (maxUnExpendRow - 1) + (maxPerRow - 1));
        }
        else {
            list = items;
        }
        setDisplayList(list);
    }, [items, expanded, maxPerRow, maxUnExpendRow]);
    // AI助手当只有免打扰通知显示免打扰标记
    //   const isAIShowShieldState = useMemo((session: any) => {
    //     if (!session || !isAINoticeSession(session)) {
    //       return false;
    //     }
    //     return aiShieldNoticeNum > 0;
    //   }, [aiShieldNoticeNum, session]);
    // const isShieldSessionOrAIShowShieldState = (session: any) => {
    //     if(isAINoticeSession(session))
    //     return isShieldSession(session) |;
    // }
    var getNumPiecesPartNode = function () {
        var unexpandSessions = items.slice(maxPerRow * (maxUnExpendRow - 1) + (maxPerRow - 1));
        return getNumPiecesPartFunction(unexpandSessions);
    };
    var handleExpandClick = function () {
        onExpandChange === null || onExpandChange === void 0 ? void 0 : onExpandChange(true);
        if (scrollContainerRef.current) {
            setScrollContainer(scrollContainerRef.current);
        }
    };
    var handleUnExpandClick = function () {
        onExpandChange === null || onExpandChange === void 0 ? void 0 : onExpandChange(false);
        setScrollContainer(null);
    };
    // 展开按钮插入到最后
    var showDropdownBtn = !expanded && total > maxVisible;
    var maxHeight = 72 * 3;
    var needScroll = expanded && displayList.length > maxPerRow * 3;
    function onChange(sourceId, sourceIndex, targetIndex) {
        console.log("拖拽排序", sourceIndex, targetIndex, displayList);
        if (sourceIndex === targetIndex)
            return;
        var nextState = swap(displayList, sourceIndex, targetIndex);
        console.log("拖拽排序结果", nextState);
        setDisplayList(nextState);
        if (onSort) {
            onSort(__spreadArrays(nextState, items.slice(nextState.length)));
        }
    }
    return (items.length > 0 ?
        React.createElement(React.Fragment, null,
            React.createElement("div", { ref: scrollContainerRef, className: styles["chat-left-topup-container"], style: { position: "relative", overflowY: needScroll ? "auto" : "hidden", height: needScroll ? maxHeight : showDropdownBtn ? maxUnExpendRow * 72 + "px" : (Math.floor((total - 1) / maxPerRow) + 1) * 72 + "px" } },
                React.createElement(GridContextProvider, { onChange: onChange, scrollContainer: scrollContainer },
                    React.createElement("div", { className: styles["chat-left-topup"], ref: containerRef },
                        React.createElement(GridDropZone, { style: { height: needScroll ? (Math.floor((total - 1) / maxPerRow) + 1) * 72 + "px" : showDropdownBtn ? maxUnExpendRow * 72 + "px" : (Math.floor((total - 1) / maxPerRow) + 1) * 72 + "px" }, className: styles["chat-left-topup-flexwrap"], id: "grid-dropone", boxesPerRow: maxPerRow, rowHeight: 72 }, displayList.map(function (item, idx) { return (React.createElement(GridItem, { className: styles["grid-item"], key: getKey(item) }, function (Component, props, _a) {
                            var dragging = _a.dragging;
                            return (React.createElement(Component, __assign({}, props), renderItem(item)));
                        })); }))),
                    showDropdownBtn &&
                        (React.createElement("div", { className: styles["chat-left-topup-dropdown"], onClick: handleExpandClick },
                            React.createElement("div", { className: styles["chat-left-topup-dropdown-img"] + " avatar-mask" },
                                React.createElement(IconFont, { className: styles["dropdown-icon"], type: "iconFrame" })),
                            React.createElement("div", { className: styles["chat-left-topup-dropdown-text"] }, "\u5C55\u5F00"),
                            getNumPiecesPartFunction && getNumPiecesPartNode())))),
            expanded && total > maxVisible && (React.createElement("div", { className: styles["chat-left-topup-collapse"], onClick: handleUnExpandClick },
                React.createElement(IconFont, { className: styles["collapse-icon"], type: "iconFrame" }),
                " \u6536\u8D77")))
        : null);
}
export default RowGrid;
//# sourceMappingURL=index.js.map